export default "__VITE_ASSET__DC4FV9dM__"